module.exports = __webpack_public_path__ + "media/excellusbcbs-home-viewports@xs-7c09e07087b58202a6c5418d889423fa.png";